export const STATE_NAME = 'favoriteListings';

export const STORAGE_KEY = 'pendingFavoriteListing';
